<template>

  <div class="container alaska-wrapper">
    <div class="row-small-gutters">
      <div class="col text-center alaska-container">
        <button class="close" @click="dismissBanner"></button>
        <h2>SPREAD THE WORD!</h2>
        <h3>Invite other fans who attended the game</h3>
        <ul class="list-inline mt-4">
          <li class="list-inline-item"><a href="#"
                                          @click.prevent="copyURL(url, $t('pages.checkins_detail.copied_title'), $t('pages.checkins_detail.copied_text'))"><img
              :src="require('@/assets/share-icons/v2/Copy.svg')"></a></li>
          <li class="list-inline-item">
            <a :href="email"
               target="_blank"><img :src="require('@/assets/share-icons/v2/Mail.svg')"></a>
          </li>
          <li class="list-inline-item">
            <a :href="telegram"
               target="_blank"><img :src="require('@/assets/share-icons/v2/Telegram.svg')"></a>
          </li>
          <li class="list-inline-item">
            <a :href="whatsapp"
               target="_blank"><img :src="require('@/assets/share-icons/v2/Whatsapp.svg')"></a>
          </li>
          <li class="list-inline-item">
            <a :href="facebook"
               target="_blank"><img :src="require('@/assets/share-icons/v2/Facebook.svg')"></a>
          </li>
        </ul>
      </div>
    </div>
  </div>

</template>

<script>

import {observeElement} from "@/utils/media";
import Gallery from "@/domain/metrics/gallery";

export default {
  name: "AlaskaCTA",
  props: {
    url: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    whatsapp: {
      type: String,
      required: true
    },
    telegram: {
      type: String,
      required: true
    },
    facebook: {
      type: String,
      required: true
    },
  },
  async mounted() {
    let linkBanner = document.querySelectorAll('.alaska-wrapper a')
    if (linkBanner) {
      linkBanner.forEach(item => {
        item.addEventListener('click', () => {
          Gallery.bannerClicked(0)
        })
      })
    }
    await observeElement(document.querySelector('.alaska-wrapper'), 3000)
  },
  methods: {
    dismissBanner() {
      document.querySelector('.alaska-wrapper').classList.add('off')
    },
    async copyURL(url, title, message) {
      try {
        await navigator.clipboard.writeText(url);
      } catch (e) {
        console.log("can't copy")
      }
      this.$bvToast.toast(`${message}`, {
        title: title,
        headerClass: 'd-block',
        toastClass: 'custom-toast-alaska',
        autoHideDelay: 3000,
      })
    }
  }
}
</script>


<style scoped>

</style>